"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tip = exports.date = exports.regexp = exports.latinLettersOnly = exports.float = exports.max = exports.min = exports.int = exports.email = exports.validPassword = exports.required = exports.VALIDATION_DATE = exports.VALIDATION_REGEXP = exports.VALIDATION_TYPE_LATIN_LETTERS = exports.VALIDATION_TYPE_FLOAT = exports.VALIDATION_TYPE_INT = exports.VALIDATION_TYPE_MAX = exports.VALIDATION_TYPE_MIN = exports.VALIDATION_TYPE_EMAIL = exports.VALIDATION_TYPE_VALID_PASSWORD = exports.VALIDATION_TYPE_REQUIRED = void 0;
var isEmail_1 = require("validator/lib/isEmail");
var isFloat_1 = require("validator/lib/isFloat");
var isInt_1 = require("validator/lib/isInt");
var isDate_1 = require("validator/lib/isDate");
var types_1 = require("./types");
var ONE_DIGIT_PATTERN = /[0-9]/;
var ONE_LOWERCASE_LETTER_PATTERN = /[a-z]/;
var ONE_UPPERCASE_LETTER_PATTERN = /[A-Z]/;
var LATIN_LETTERS_ONLY_PATTERN = /^[A-Za-z\s]+$/;
var PASSWORD_MIN_LENGTH = 8;
var PASSWORD_MAX_LENGTH = 100;
exports.VALIDATION_TYPE_REQUIRED = 'validators:required';
exports.VALIDATION_TYPE_VALID_PASSWORD = 'validators:validPassword';
exports.VALIDATION_TYPE_EMAIL = 'validators:email';
exports.VALIDATION_TYPE_MIN = 'validators:min';
exports.VALIDATION_TYPE_MAX = 'validators:max';
exports.VALIDATION_TYPE_INT = 'validators:int';
exports.VALIDATION_TYPE_FLOAT = 'validators:float';
exports.VALIDATION_TYPE_LATIN_LETTERS = 'validators:latinOnly';
exports.VALIDATION_REGEXP = 'validators:regexp';
exports.VALIDATION_DATE = 'validators:date';
var required = function (message, options) {
    if (message === void 0) { message = exports.VALIDATION_TYPE_REQUIRED; }
    return function (value) {
        var stringIsEmpty = typeof value === 'string' && value.replace(/\s/g, '').length === 0;
        return (!value || stringIsEmpty) && { key: message, options: options };
    };
};
exports.required = required;
var validPassword = function (message, options) {
    if (message === void 0) { message = exports.VALIDATION_TYPE_VALID_PASSWORD; }
    return function (value) {
        return value &&
            (!ONE_DIGIT_PATTERN.test(value) ||
                !ONE_LOWERCASE_LETTER_PATTERN.test(value) ||
                !ONE_UPPERCASE_LETTER_PATTERN.test(value) ||
                value.length < PASSWORD_MIN_LENGTH ||
                value.length > PASSWORD_MAX_LENGTH)
            ? { key: message, options: options }
            : false;
    };
};
exports.validPassword = validPassword;
var email = function (message, options) {
    if (message === void 0) { message = exports.VALIDATION_TYPE_EMAIL; }
    return function (value) {
        return value && !isEmail_1.default(value) ? { key: message, options: options } : false;
    };
};
exports.email = email;
var int = function (settings, message, options) {
    if (message === void 0) { message = exports.VALIDATION_TYPE_INT; }
    return function (value) {
        return value && !isInt_1.default(value, settings) ? { key: message, options: options } : false;
    };
};
exports.int = int;
var min = function (min, message, options) {
    if (message === void 0) { message = exports.VALIDATION_TYPE_MIN; }
    return function (value) {
        return value && value < min ? { key: message, options: __assign({ min: min }, options) } : false;
    };
};
exports.min = min;
var max = function (max, message, options) {
    if (message === void 0) { message = exports.VALIDATION_TYPE_MAX; }
    return function (value) {
        return value && (value > max || value > Number.MAX_SAFE_INTEGER)
            ? {
                key: message,
                options: __assign({ max: max }, options)
            }
            : false;
    };
};
exports.max = max;
var float = function (message, options) {
    if (message === void 0) { message = exports.VALIDATION_TYPE_FLOAT; }
    return function (value) {
        return value && !isFloat_1.default(value) ? { key: message, options: options } : false;
    };
};
exports.float = float;
var latinLettersOnly = function (message, options) {
    if (message === void 0) { message = exports.VALIDATION_TYPE_LATIN_LETTERS; }
    return function (value) {
        return value && !LATIN_LETTERS_ONLY_PATTERN.test(value) ? { key: message, options: options } : false;
    };
};
exports.latinLettersOnly = latinLettersOnly;
var regexp = function (expr, message, options) {
    if (message === void 0) { message = exports.VALIDATION_REGEXP; }
    return function (value) {
        return value && !expr.test(value) ? { key: message, options: options } : false;
    };
};
exports.regexp = regexp;
var date = function (format, message) {
    return function (value) {
        return value && !isDate_1.default(value, { format: format, delimiters: ['.', '/', '-'] })
            ? {
                key: message || 'validator:date',
                options: {}
            }
            : false;
    };
};
exports.date = date;
var tip = function (message, options, level) {
    if (level === void 0) { level = types_1.TipLevels.TIP; }
    return function () { return ({ key: message, options: options, level: level }); };
};
exports.tip = tip;
//# sourceMappingURL=validators.js.map